import { useMutation, useQuery } from "@tanstack/react-query";
import { NotificationToast } from "Components/Generic/Toast/NotificationToast";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ExpensesService from "Services/expenses.service";
import { ExpensesKeys } from "Util/queries";

interface FetchExpenseListProps {
  taskId: number;
  page: number;
  pageSize: number;
  requirement?: string;
  enabled?: boolean;
}

const getIncludeParam = (requirement?: string) => {
  return JSON.stringify([
    {
      association: "member",
      required: requirement?.trim() && requirement === "members" ? true : false,
    },
    {
      association: "fleet",
      required: requirement?.trim() && requirement === "fleets" ? true : false,
    },
  ]);
};


const getFilterParams = (requirement?: string) => {
  const isOthersFilter = requirement?.trim() && requirement === "others";
  return {
    memberId: isOthersFilter ? "" : undefined,
    fleetId: isOthersFilter ? "" : undefined,
  };
};

export const useExpenseHooks = () => {
  const { t: translate } = useTranslation();

  const fetchExpensesList = ({
    taskId,
    page,
    pageSize,
    requirement,
    enabled,
  }: FetchExpenseListProps) => {
    const { refetch, data, isFetching } = useQuery({
      queryKey: ExpensesKeys.getAll([page, pageSize, requirement]),
      queryFn: async () => ExpensesService.getAll({
        page,
        pageSize,
        taskId,
        include: getIncludeParam(requirement),
        ...getFilterParams(requirement),
      }).then((res) => res.data),
      enabled,
      refetchOnWindowFocus: false,
    })

    return {
      refetch,
      data,
      isFetching,
    };
  }

  const recalculateExpenses = (callback?: () => void) => {
    return useMutation({
      mutationKey: [ExpensesKeys.all],
      mutationFn: async (taskId: number) => ExpensesService.autoCalculateExpensesBasedOnTimeSheet({ taskId }),
      onSuccess: () => {
        NotificationToast.success(translate("expensesRecalculatedSuccessfully"));
        if (callback) {
          callback();
        }
      }
    })
  }

  return {
    fetchExpensesList,
    recalculateExpenses,
  };
};
